import React, { lazy } from 'react';
import { GraduationCapIcon, FileTextIcon, ClockIcon, ShieldCheckIcon, AccessibilityIcon, MonitorIcon } from 'lucide-react';
const AVATARS = ['https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=80&h=80&fit=crop&crop=faces&q=80', 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=80&h=80&fit=crop&crop=faces&q=80', 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=80&h=80&fit=crop&crop=faces&q=80', 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=faces&q=80', 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=80&h=80&fit=crop&crop=faces&q=80'];
const METRICS = [{
  icon: GraduationCapIcon,
  value: '1.500+',
  label: 'Scuole italiane',
  sub: 'utilizzano già i nostri materiali'
}, {
  icon: FileTextIcon,
  value: '420.000+',
  label: 'Schede artistiche scaricate',
  sub: 'da inizio anno'
}, {
  icon: ClockIcon,
  value: '96%',
  label: 'Risparmia 4h+',
  sub: 'di lavoro a settimana'
}];
const CREDIBILITY = [{
  icon: ShieldCheckIcon,
  label: 'Allineato Indicazioni Nazionali'
}, {
  icon: AccessibilityIcon,
  label: 'Compatibile BES & DSA'
}, {
  icon: MonitorIcon,
  label: 'Perfetto per LIM, tablet e stampa A4'
}];
export function TrustBar() {
  return <section aria-label="Prova sociale e credibilità istituzionale" className="w-full bg-bg-alt border-y border-border-light px-4 py-7 sm:py-10 relative overflow-hidden" data-id="element-400">
      {/* Subtle accent dots */}
      <div className="absolute -top-32 left-1/4 w-72 h-72 rounded-full pointer-events-none opacity-40" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.10) 0%, transparent 60%)'
    }} aria-hidden="true" data-id="element-401" />
      <div className="absolute -bottom-32 right-1/4 w-72 h-72 rounded-full pointer-events-none opacity-40" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.08) 0%, transparent 60%)'
    }} aria-hidden="true" data-id="element-402" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-403">
        {/* Top row — Community statement with avatar stack */}
        <div className="flex items-center justify-center gap-3 sm:gap-4 mb-6 sm:mb-8 flex-wrap" data-id="element-404">
          <div className="flex -space-x-2.5" data-id="element-405">
            {AVATARS.map((src, i) => <img key={i} src={src} alt="" loading="lazy" width={36} height={36} className="w-9 h-9 sm:w-10 sm:h-10 rounded-full border-2 border-bg-alt object-cover bg-bg-dark" data-id="element-406" />)}
            <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full border-2 border-bg-alt bg-primary/20 flex items-center justify-center" data-id="element-407">
              <span className="text-primary text-[10px] sm:text-[11px] font-black" data-id="element-408">
                +18K
              </span>
            </div>
          </div>
          <p className="text-text-main text-sm sm:text-base font-semibold leading-snug text-center sm:text-left" data-id="element-409">
            La community di{' '}
            <span className="text-primary font-black" data-id="element-410">
              18.000+ maestre creative italiane
            </span>{' '}
            <span className="text-text-sec font-medium" data-id="element-411">
              🇮🇹 da Aosta a Palermo
            </span>
          </p>
        </div>

        {/* Middle row — 3 hard usage metrics */}
        <div className="grid grid-cols-3 gap-2 sm:gap-4 mb-6 sm:mb-8" data-id="element-412">
          {METRICS.map((m, i) => {
          const Icon = m.icon;
          return <div key={i} className="flex flex-col items-center text-center bg-bg-dark/40 border border-white/10 rounded-xl px-2 py-3 sm:px-4 sm:py-5" data-id="element-413">
                <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-primary mb-1.5 sm:mb-2" strokeWidth={2.25} data-id="element-414" />
                <p className="text-text-main font-black text-base sm:text-2xl leading-none tracking-tight" data-id="element-415">
                  {m.value}
                </p>
                <p className="text-text-main font-bold text-[10px] sm:text-xs mt-1 sm:mt-1.5 leading-tight" data-id="element-416">
                  {m.label}
                </p>
                <p className="text-text-sec text-[9px] sm:text-[11px] font-medium leading-tight mt-0.5 hidden sm:block" data-id="element-417">
                  {m.sub}
                </p>
              </div>;
        })}
        </div>

        {/* Bottom row — Credibility / compliance badges */}
        <div className="border-t border-border-light pt-4 sm:pt-5" data-id="element-418">
          <p className="text-center text-text-sec text-[9px] sm:text-[11px] font-bold uppercase tracking-[0.2em] mb-3" data-id="element-419">
            Standard professionale
          </p>
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-420">
            {CREDIBILITY.map((c, i) => {
            const Icon = c.icon;
            return <div key={i} className="inline-flex items-center gap-1.5 sm:gap-2 bg-bg-dark/50 border border-white/10 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full" data-id="element-421">
                  <Icon className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-cta-green flex-shrink-0" strokeWidth={2.5} data-id="element-422" />
                  <span className="text-text-main text-[10px] sm:text-xs font-bold whitespace-nowrap" data-id="element-423">
                    {c.label}
                  </span>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}